import { ERROR_CODES } from "onearm";
import { GameStates } from "onearm";
import { SubGameState } from "./SubGameState";

export class ErrorState extends SubGameState {
    enter(error) {
        const { custom_message, code } = error;
        // disable interaction
        // this.gameState.interactive = false;
        // this.gameState.interactiveChildren = false;

        console.error(error);
        const errorPopupOptions = {
            title: "ERROR",
            message: custom_message || "INTERNAL ERROR",
            showCloseButton: false,
        };

        if (code === ERROR_CODES.NOT_ENOUGH_BALANCE) {
            errorPopupOptions.title = "NOT ENOUGH FUNDS";
            errorPopupOptions.message = custom_message || "Your balance is not enough to play";
            errorPopupOptions.showCloseButton = true;
            errorPopupOptions.showReloadButton = false;
        }

        if (code === ERROR_CODES.SESSION_EXPIRED) {
            errorPopupOptions.title = "SESSION EXPIRED";
            errorPopupOptions.message =
                custom_message || "Your session has expired,\\nplease reload the page";
            errorPopupOptions.showCloseButton = false;
            errorPopupOptions.showReloadButton = true;
        }

        this.popup = this.scenes.add("ErrorPopupScene", errorPopupOptions);
        this.addSignalHandler(this.popup.onPressClose, this.onPressCloseHandler);
        this.addSignalHandler(this.popup.onPressReload, this.onPressReloadHandler);
        this.popup.show("ErrorPopupScene");
    }

    exit() {
        this.scenes.remove("ErrorPopupScene");
    }

    onPressCloseHandler() {
        this.owner.goTo(GameStates.IDLE);
    }

    onPressReloadHandler() {
        window.location.reload();
    }
}
